import { Header, Table } from '@amzn/awsui-components-react';
import { Component } from 'react';
import { Dashboard } from './Dashboard';
import { personalColumnDefinitions } from './personal/Personal';
import ServiceAppLayout from '../../components/ServiceAppLayout';

export class DashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flashBarError: false,
      flashBarSuccess: false,
      header: '',
      userContent: '',
    };
    this.headerUpdater = this.headerUpdater.bind(this);
  }

  headerUpdater(header, data) {
    this.setState({
      header: header,
      userContent: (
        <Table
          header={<Header>Aggregated Data for {header}'s Direct Reports</Header>}
          columnDefinitions={personalColumnDefinitions}
          items={data}
        />
      ),
    });
  }

  render() {
    return (
      <ServiceAppLayout
        className="awsui-util-no-gutters"
        page="MetricsHomePage"
        content={
          <div style={{ minHeight: '100vh' }}>
            <Dashboard {...this.props} headerUpdater={this.headerUpdater} />
          </div>
        }
        toolsHide={true}
      />
    );
  }
}
